export enum NotificationsRpcMethods {
    STATE = 'account.state',
    CHECK = 'account.check',
    NEW = 'account.new',
    UPDATE = 'account.update'
}
